export function valueMatched(
  value: string,
  match: string | null,
  type: string | null = null,
  isTextArea = false
): string {
  const matchTypeMapping: Record<string, RegExp> = {
    currency: /[0-9-.]/,
    length: /[0-9]/,
    weight: /[0-9]/,
    percentage: /[0-9,.]/
  }
  let regExp: RegExp | null = null
  const predefinedMatches: Record<string, RegExp> = {
    alpha: /[A-Za-z]/,
    alphanum: /[A-Za-z0-9]/,
    alphanum_minus: /[A-Za-z0-9-_]/,
    num: /[0-9-,.]/,
    number: /[0-9-]/,
    latin: /[\u0020-\u007E\u00A0-\u1EF9]/
  }
  const predefinedMatchesWithNewline: Record<string, RegExp> = {
    alpha: /[A-Za-z\n]/,
    alphanum: /[A-Za-z0-9\n]/,
    alphanum_minus: /[A-Za-z0-9-_\n]/,
    num: /[0-9-,.\n]/,
    number: /[0-9-,.\n]/,
    latin: /[\u0020-\u007E\u00A0-\u1EF9\n]/
  }
  if (match !== null && match in predefinedMatches) {
    regExp = isTextArea ? predefinedMatchesWithNewline[match] : predefinedMatches[match]
  } else if (match !== null) {
    regExp = new RegExp(match)
  } else if (type !== null && type in matchTypeMapping) {
    regExp = matchTypeMapping[type]
  }
  if (regExp === null) return value

  return value
    .split('')
    .filter(char => regExp?.test(char))
    .join('')
}
